var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreatorDisk = function SvgCreatorDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#creator-disk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.812 28.37 70.099 3.14A47.876 47.876 0 0 0 53 0C26.49 0 5 21.49 5 48a47.826 47.826 0 0 0 4.186 19.63l26.712 25.23c3.894 1.02 10.712.965 14.926.965 26.509 0 47.999-21.49 47.999-48 0-5.129-.522-12.821-2.011-17.455zM52.999 59.087c-1.392 0-2.722-.259-3.95-.727h-6.167v-5.828a11.044 11.044 0 0 1-.97-4.532c0-6.124 4.964-11.087 11.087-11.087 1.391 0 2.722.259 3.949.727h6.168v5.827c.62 1.384.97 2.918.97 4.533 0 6.123-4.964 11.087-11.087 11.087z",
    fill: "url(#creator-disk_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.713 29.307a47.962 47.962 0 0 1 2.297 14.701c0 26.51-21.49 48-48 48-4.212 0-8.298-.545-12.192-1.564h-.92v2.413A47.876 47.876 0 0 0 53 95.997c26.509 0 47.999-21.49 47.999-48a47.826 47.826 0 0 0-4.186-19.63h-2.098v.94z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.052 58.359a11.12 11.12 0 0 1-6.168-5.828L9.187 67.628a48.044 48.044 0 0 0 7.94 12.257c6.204 5.843 13.963 10.561 19.693 10.561L49.052 58.36z",
    fill: "url(#creator-disk_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.945 37.64a11.12 11.12 0 0 1 6.168 5.828L94.71 29.312c0-4.656-3.536-10.401-9.828-17.186a47.975 47.975 0 0 0-14.785-8.985l-13.152 34.5z",
    fill: "url(#creator-disk_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.81 28.378a48.13 48.13 0 0 0-11.927-16.245 47.933 47.933 0 0 1 9.828 17.185l2.1-.94z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.133 79.883a48.079 48.079 0 0 0 18.773 12.974l.92-2.413a47.883 47.883 0 0 1-19.693-10.561z",
    fill: "#D5D6D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.101,
    cy: 49.101,
    fill: "#29292C",
    r: 13.749
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "creator-disk_svg__b",
    x1: 51.911,
    y1: 0,
    x2: 51.911,
    y2: 93.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creator-disk_svg__c",
    x1: 29.12,
    y1: 52.531,
    x2: 46.351,
    y2: 87.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#D2DADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creator-disk_svg__d",
    x1: 75.828,
    y1: 3.141,
    x2: 81.078,
    y2: 40.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#D1D7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE3E7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "creator-disk_svg__a",
    x: 0.2,
    y: 0,
    width: 105.6,
    height: 105.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16254_511620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_16254_511620",
    result: "shape"
  })))));
};
export default SvgCreatorDisk;